<template>
  <div class="app-header">
    <!-- 顶部 Header -->
    <header class="header">
      <div class="container header-container">
        <div class="logo" @click="$router.push('/')">
          <img :src="logoUrl" alt="吕氏家谱网">
        </div>
        <div class="search-box">
          <div class="search-con">
            <img class="search-icon" src="/img/search.png" alt="搜索">
            <input 
              type="text" 
              placeholder="请输入您要搜索的内容"
              v-model="searchText"
              @keyup.enter="handleSearch"
            >
            <select v-model="searchType">
              <option value="all">全部</option>
              <option value="surname">姓氏</option>
              <option value="name">名字</option>
            </select>
            <button @click="handleSearch">搜索</button>
          </div>
          <!-- 未登录状态：显示登录和注册按钮 -->
          <div class="login-register" v-if="!isLogin">
            <button class="login-btn" @click="$router.push('/login')">登录</button>
            <button class="register-btn" @click="$router.push('/register')">注册</button>
          </div>
          <!-- 已登录状态：显示用户头像 -->
          <div class="user-avatar-wrapper" v-else @click="$router.push('/center')" title="进入个人中心">
            <img 
              :src="userInfo.avatar || '/img/center/avatar.jpg'" 
              class="user-avatar" 
              alt="用户头像"
            >
            <span class="user-name">{{ userInfo.nickname || userInfo.username || '用户' }}</span>
          </div>
        </div>
      </div>
    </header>

    <!-- 瀵艰埅 -->
    <nav class="nav">
      <div class="container">
        <ul class="nav-list">
          <li 
            class="nav-item" 
            v-for="item in navItems" 
            :key="item.id"
            @mouseenter="activeNav = item.id"
            @mouseleave="activeNav = null"
          >
            <router-link :to="item.url" class="nav-link">
              {{ item.name }}
              <span v-if="item.hasDropdown" class="dropdown-arrow">▼</span>
            </router-link>
            <div 
              v-if="item.hasDropdown && activeNav === item.id" 
              class="dropdown-menu"
            >
              <ul class="dropdown-list">
                <li 
                  class="dropdown-item" 
                  v-for="subItem in item.dropdownItems" 
                  :key="subItem.id"
                >
                  <router-link :to="subItem.url" class="dropdown-link">
                    {{ subItem.name }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { getSiteConfig, getNavigation } from '@/api/config'
import { getUserProfile, logout } from '@/api/user'

export default {
  name: 'AppHeader',
  data() {
    return {
      searchText: '',
      searchType: 'all',
      activeNav: null,
      siteConfig: {},
      // 榛樿瀵艰埅鏁版嵁锛圓PI澶辫触鏃朵娇鐢級
      navItems: [],
      isLogin: false,
      userInfo: {}
    }
  },
  created() {
    this.fetchConfig()
    this.checkLogin()
  },
  computed: {
    logoUrl() {
      return this.normalizeAssetUrl(this.siteConfig && this.siteConfig.logo, '/img/logo.png')
    }
  },
  methods: {
    normalizeAssetUrl(url, fallback = '') {
      if (!url) return fallback
      if (/^https?:\/\//i.test(url) || url.startsWith('/')) return url
      return `/${url.replace(/^\/+/, '')}`
    },
    async fetchConfig() {
      const [siteResult, navResult] = await Promise.allSettled([
        getSiteConfig(),
        getNavigation()
      ])

      if (siteResult.status === 'fulfilled') {
        this.siteConfig = siteResult.value || {}
      } else {
        console.error('获取站点配置失败:', siteResult.reason)
        this.siteConfig = { logo: '/img/logo.png', footerLogo: '/img/footer-logo.png' }
      }

      if (navResult.status === 'fulfilled') {
        this.navItems = Array.isArray(navResult.value && navResult.value.navItems) ? navResult.value.navItems : []
        console.log('【导航菜单】已从API加载', this.navItems.length, '个菜单项')
      } else {
        console.warn('导航配置接口不可用，使用空导航:', navResult.reason)
        this.navItems = []
      }
    },
    async checkLogin() {
      const token = localStorage.getItem('token')
      if (token) {
        try {
          this.userInfo = await getUserProfile()
          this.isLogin = true
        } catch (error) {
          localStorage.removeItem('token')
        }
      }
    },
    handleSearch() {
      if (this.searchText.trim()) {
        this.$router.push({
          path: '/search',
          query: { keyword: this.searchText, type: this.searchType }
        })
      }
    },
    async handleLogout() {
      try {
        await logout()
        localStorage.removeItem('token')
        this.isLogin = false
        this.userInfo = {}
        this.$router.push('/')
      } catch (error) {
        console.error('閫€鍑哄け璐?', error)
      }
    }
  }
}
</script>

<style scoped>
.header {
  background-color: #fff;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo img {
  width: 205px;
  height: 58px;
  margin-right: 10px;
}

.search-box {
  display: flex;
  align-items: center;
}

.search-box .search-con {
  width: 580px;
  height: 41px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  background: url(~@/assets/img/search-con.png) no-repeat center center;
  background-size: 100% 100%;
}

.search-box .search-con .search-icon {
  width: 13px;
  height: 14px;
  margin-left: 14px;
}

.search-box .search-con input {
  flex: 1;
  height: 28px;
  padding: 0 10px;
  margin: 0 10px;
  border: none;
  font-size: 14px;
  color: #6c6c6c;
  background: transparent;
}

.search-box .search-con input:focus {
  outline: none;
}

.search-box .search-con select {
  height: 28px;
  padding: 0 10px;
  border: none;
  background-color: #856147;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

.search-box .search-con select option {
  background-color: #856147;
}

.search-box .search-con button {
  height: 28px;
  padding: 0 20px;
  margin-left: 8px;
  background-color: #856147;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.login-register {
  display: flex;
  margin-left: 20px;
}

.login-btn,
.register-btn {
  height: 40px;
  padding: 0 20px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.login-btn {
  background-color: #fff;
  color: #333;
  border: 1px solid #ddd;
}

.login-btn:hover {
  border-color: #856147;
  color: #856147;
}

.register-btn {
  background-color: #dc143c;
  color: #fff;
}

.register-btn:hover {
  background-color: #b01030;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: 20px;
}

.user-info span {
  cursor: pointer;
  color: #856147;
  font-size: 14px;
}

.user-info span:hover {
  text-decoration: underline;
}

/* 用户头像样式 */
.user-avatar-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 20px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 20px;
  transition: background-color 0.3s;
}

.user-avatar-wrapper:hover {
  background-color: rgba(133, 97, 71, 0.1);
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #856147;
}

.user-name {
  color: #856147;
  font-size: 14px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 瀵艰埅鏍峰紡 */
.nav {
  background-color: #856147;
  position: relative;
  z-index: 1000;
}

.nav .container {
  padding: 0;
  justify-content: center;
}

.nav-list {
  display: flex;
  list-style: none;
}

.nav-item {
  margin: 0 10px;
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 15px 10px;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  line-height: 1.5;
  transition: background-color 0.3s;
}

.nav-link:hover {
  background-color: #6d4e3a;
}

.dropdown-arrow {
  font-size: 10px;
  margin-left: 5px;
  transition: transform 0.3s;
}

.nav-item:hover .dropdown-arrow {
  transform: rotate(180deg);
}

/* 涓嬫媺鑿滃崟鏍峰紡 */
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 1001;
  animation: dropdownFade 0.3s ease-out;
}

@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-item {
  border-bottom: 1px solid #f0f0f0;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-link {
  display: block;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s;
}

.dropdown-link:hover {
  background-color: #f5f5f5;
  color: #856147;
  padding-left: 25px;
}
</style>


